import * as exifr from 'exifr';

export function photoCoordinates(image, result) {
  for (const item of [result, image]) {
    for (const source of [item, item?.gps, item?.metadata, item?.exif]) {
      for (const [lat, lon] of [[source?.imageLat, source?.imageLon], [source?.latitude, source?.longitude], [source?.lat, source?.lon ?? source?.lng]]) {
        if (lat == null || lon == null || String(lat).trim() === '' || String(lon).trim() === '') continue;
        const point = [Number(lat), Number(lon)];
        if (point.every(Number.isFinite) && Math.abs(point[0]) <= 90 && Math.abs(point[1]) <= 180) return point;
      }
    }
  }
  return null;
}

export async function readImageMetadata(file) {
  try {
    const data = await exifr.parse(file, { gps: true, pick: ['latitude', 'longitude', 'GPSLatitude', 'GPSLongitude', 'GPSLatitudeRef', 'GPSLongitudeRef', 'DateTimeOriginal'] });
    const point = photoCoordinates(data);
    const date = data?.DateTimeOriginal;
    return { lat: point?.[0] ?? null, lon: point?.[1] ?? null, capturedAt: date instanceof Date && Number.isFinite(date.getTime()) ? date.toISOString() : null };
  } catch { return { lat: null, lon: null, capturedAt: null }; }
}

export async function buildRegisterRequest(files, signedItems) {
  const images = [];
  for (let index = 0; index < files.length; index += 1) {
    images.push({ imageName: files[index].name, imagePath: signedItems[index].gsUrl, ...await readImageMetadata(files[index]) });
  }
  return { images };
}
